import { IoMdClose } from 'react-icons/io';
import { Button } from '@/components/shadcn/default/button';
import { cn } from '@/lib/utils';

type PrimaryChipProps = {
  label: string;
  className?: string;
};

export const PrimaryChip = ({ label, className }: PrimaryChipProps) => {
  return (
    <p
      className={cn(
        'rounded-1 text-secondary-dark-default border border-[#B8D4FC] px-2 text-sm font-normal bg-[#F3F9FE]',
        className,
      )}
    >
      {label}
    </p>
  );
};

type SecondaryChipProps = {
  label: string;
  className?: string;
};

export const SecondaryChip = ({ label, className }: SecondaryChipProps) => {
  return (
    <p
      className={cn(
        'rounded-1 text-shade-medium-default border border-shade-medium-default px-3 py-1 text-sm font-normal bg-shade-white-default',
        className,
      )}
    >
      {label}
    </p>
  );
};

type PrimaryChipWithButtonProps = {
  label: string;
  className?: string;
  onClose: () => void;
};

export const PrimaryChipWithButton = ({ label, className, onClose }: PrimaryChipWithButtonProps) => {
  return (
    <div className="rounded-1 text-secondary-dark-default flex items-center border border-[#B8D4FC] bg-[#F3F9FE]">
      <p className={cn('px-2 text-base font-normal ', className)}>{label}</p>

      <Button
        variant="ghost"
        size="icon"
        className="flex h-7 w-7 items-center justify-center rounded-l-none border-l border-[#B8D4FC] bg-[#F3F9FE] p-1.5"
        onClick={onClose}
      >
        <IoMdClose size={16} className="text-secondary-xdark-default" />
      </Button>
    </div>
  );
};
